import { I18N_LOCALES, type I18nLocale } from 'i18n/types/I18nLocale';

import { PageFooterLocaleLinksItem } from './Item/PageFooterLocaleLinksItem';
import { PageFooterLocaleLinksHolder } from './PageFooterLocaleLinks.styled';

type Props = {
  urlByLocale: Record<I18nLocale, string | undefined> | undefined;
};

export function PageFooterLocaleLinks({ urlByLocale }: Props) {
  return (
    <PageFooterLocaleLinksHolder>
      {I18N_LOCALES.map((linkLocale) => (
        <PageFooterLocaleLinksItem
          key={linkLocale}
          linkLocale={linkLocale}
          localeUrl={urlByLocale?.[linkLocale]}
        />
      ))}
    </PageFooterLocaleLinksHolder>
  );
}
